import { render } from "./cart-area.vue?vue&type=template&id=7aadfc98"
import script from "./cart-area.vue?vue&type=script&lang=js"
export * from "./cart-area.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__